var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100 px-4"},[_c('div',{staticClass:"w-100"},[_c('h1',[_vm._v(_vm._s(_vm.firstData(_vm.dataList).titleH1))]),_c('h2',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.firstData(_vm.dataList).titleH2))])])])}
var staticRenderFns = []

export { render, staticRenderFns }